import React from 'react';

import {
    Heading,
    Container,
    Row,
    Col,
    Text,
    className,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import textStyle from 'aplazame-design-system/src/scss/text.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';
import style from './style.module.scss';

export default function ButtonSection({
    title,
    titleTag,
    text,
    id,
    buttons,
    colorScheme,
}) {
    colorScheme = colorScheme?.toLowerCase();
    const hasColorScheme = colorScheme !== 'none';

    return (
        <section
            {...className(
                `${colorStyle[`with-bg--${colorScheme}`]} ${sectionStyle['with-bg']
                } ${sectionStyle['with-bg--none']} mt-10 mt-lg-20`
            )}
            aria-labelledby={id}
        >
            {hasColorScheme ? (
                <div
                    data-sal="fade"
                    className={`${sectionStyle.bg} ${colorStyle.bg}`}
                />
            ) : null}
            <Container pt={{ xs: 10, lg: 20 }} pb={{ xs: 10, lg: 20 }}>
                <Row className="text-lg-center">
                    <Col col={{ lg: 10 }} offset={{ lg: 1 }}>
                        <Heading
                            id={id}
                            tag={titleTag}
                            className={`h2 ${textStyle.gradual} mb-5`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                    <Col col={{ lg: 8 }} offset={{ lg: 2 }}>
                        <Text
                            tag="div"
                            className={`h3 mb-8 ${style.text}`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {text}
                        </Text>
                    </Col>
                    <Col
                        col={{
                            lg: 6,
                            xl: 4,
                        }}
                        offset={{
                            lg: 3,
                            xl: 4,
                        }}
                        data-sal="slide-up"
                        data-sal-easing="ease-out-quart"
                    >
                        <ButtonComponent
                            buttonClassName={`mb-2 ${style.fixButton}`}
                            blockMobile={true}
                            buttons={buttons.map((button) => ({
                                ...button,
                                block: true,
                            }))}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
